'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareBody = exports.checkBody = undefined;

var _isFunction = require('../validators/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: Preparing the body of the fetch call
 * @param {any} body :: The body that needs to be prepared
 * @return {any} :: Prepared body
 */


var checkBody = exports.checkBody = function checkBody(body) {
  return (0, _isFunction2.default)(body) ? body() : body;
};
/**
 * @description :: Preparing the body for the fetch execution
 * @param {any} profileBody :: The body that was set in the profile
 * @param {any} body :: The body that was set in in an individual fetch
 * @return {any} :: existing body
 */
// Validators


var prepareBody = exports.prepareBody = function prepareBody(profileBody, body) {
  if (body) return checkBody(body);
  if (profileBody) return checkBody(profileBody);
  return null;
};